export default {
	paper: {
		overflowY: 'visible',
	},
};
